module.exports = __webpack_public_path__ + "media/images/logo-404660d3e469c80b7b6344cd297e6033.png";